import axios from 'axios';
import React, {useEffect, useState, useMemo} from 'react'
import {loadStripe} from '@stripe/stripe-js';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Loader from '../../utils/Loader';
import DemoDataTable from './DemoDataTable'
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./DemoTable.css"
import BigNumber from 'bignumber.js'
import sound_1 from "../../../Alerts/sound_1.mp3"
import sound_2 from "../../../Alerts/sound_2.mp3"
import sound_3 from "../../../Alerts/sound_3.mp3"
import sound_4 from "../../../Alerts/sound_4.mp3"
import sound_5 from "../../../Alerts/sound_5.mp3"
import sound_6 from "../../../Alerts/sound_6.mp3"


const {USDT_SYMBOLS, BINANCE_SYMBOLS_USD} = require('./Symbols_Data')

function DemoTable() {

  const [alert, setAlert] = useState({ c10s:false, c20s:false, c30s:false, c1m:false, c3m:false, c5m:false, 
    c1h:false, c2h:false, c3h:false, c4h:false, c1d:false, c7d:false, c30d:false, c1y:false})

  const {user} = useSelector(state => state.auth)
  let timeSendMail = '1671989426000'

  const [searchText, setSearchText] = useState("")

  const [loading, setLoading] = useState(true)

  const [activeAlert, setActiveAlert] = useState(false)
  const [percentages, setPercentages] = useState([]) // {symbol: , symbol_name: , price: , usd1s: , usd5min: ,  }

  const [AlertFile, setAlertFile] = useState(sound_1)
  let audioAlert1 = useMemo(() => new Audio(sound_1), [AlertFile]);
  let audioAlert2 = useMemo(() => new Audio(sound_2), [AlertFile]);
  let audioAlert3 = useMemo(() => new Audio(sound_3), [AlertFile]);
  let audioAlert4 = useMemo(() => new Audio(sound_4), [AlertFile]);
  let audioAlert5 = useMemo(() => new Audio(sound_5), [AlertFile]);
  let audioAlert6 = useMemo(() => new Audio(sound_6), [AlertFile]);

  var Last10s = []
  var countLast10s = -1

  // GET ALL COINS SYMBOLS AND PRICES
  useEffect(async () => {
    // Initialisation on the Table from QuantifyCrypto
    initData()
      
    getPercentages()

    // Handle the seconds column & the prices with Binance Websocket
    let URL1minute = `wss://stream.binance.com:9443/stream?streams=`
    let URL3minute = `wss://stream.binance.com:9443/stream?streams=`
    let URLseconds = 'https://data.binance.com/api/v3/ticker/price?symbols=['

    getSecondPrices_USDT()

    for(let i=0; i<USDT_SYMBOLS.length; i++){
      URL1minute = URL1minute + USDT_SYMBOLS[i].toLowerCase() + '@kline_1m/'
      URL3minute = URL3minute + USDT_SYMBOLS[i].toLowerCase() + '@kline_3m/'
    }

    URL1minute = URL1minute.slice(0, -1);
    URL3minute = URL3minute.slice(0, -1);

    get1Minute(URL1minute, 'USDT')
    get3Minute(URL3minute, 'USDT')

    setLoading(false)

  }, [])

  const initData = async () => {
    try {
      const res = await axios.get('https://iq-screener-backend-a7au.vercel.app/api/crypto/init-table/USDT')
      setPercentages(res.data)
    }
    catch (err) {
      toast.error('Error', { containerId:'DisplayInfo', theme: "colored" })
    }

  }

  const getPercentages = () => {
    const baseURL = "https://eventstream.quantifycrypto.com/ptc-change-broadcast";
    const source = new EventSource(baseURL)
    source.onmessage = e => {

      let data = JSON.parse(e.data)
      let Alert = localStorage.getItem('DemoDataAlert') ? JSON.parse(localStorage.getItem('DemoDataAlert')) : {}

      setPercentages(prevState => {
        const newState = prevState.map(obj => {

          // if the symbol exist in the table
          if (obj.symbol === data.qc_key) {
            if(data.change_usd_5min){
              checkForAlert('c5m', obj.symbol, data.change_usd_5min, '5 minutes', Alert)
              return {...obj, usd5min: data.change_usd_5min};
            }
            else if(data.change_usd_1h){
              checkForAlert('c1h', obj.symbol, data.change_usd_1h, '1 hour', Alert)
              return {...obj, usd1h: data.change_usd_1h};
            }
            else if(data.change_usd_2h){
              checkForAlert('c2h', obj.symbol, data.change_usd_2h, '2 hours', Alert)
              return {...obj, usd2h: data.change_usd_2h};
            }
            else if(data.change_usd_4h){
              checkForAlert('c4h', obj.symbol, data.change_usd_4h, '4 hours', Alert)
              return {...obj, usd4h: data.change_usd_4h};
            }
            else if(data.change_usd_24h){
              checkForAlert('c1d', obj.symbol, data.change_usd_24h, '1 day', Alert)
              return {...obj, usd1d: data.change_usd_24h};
            }
            else if(data.change_usd_7d){
              checkForAlert('c7d', obj.symbol, data.change_usd_7d, '1 week', Alert)
              return {...obj, usd7d: data.change_usd_7d};
            }
            else if(data.change_usd_30d){
              checkForAlert('c30d', obj.symbol, data.change_usd_30d, '1 month', Alert)
              return {...obj, usd30d: data.change_usd_30d};
            }
            else if(data.change_usd_1year){
              checkForAlert('c1y', obj.symbol, data.change_usd_1year, '1 year', Alert)
              return {...obj, usd1y: data.change_usd_1year};
            }
          }

          // otherwise return object as is
          return obj;
        });

        return newState;
      });

    }
  }

  const get1Minute = (url, suffix1, suffix2) => {
    let connection1minute = new WebSocket(url);
    connection1minute.onmessage = evt => { 
      let Alert = localStorage.getItem('DemoDataAlert') ? JSON.parse(localStorage.getItem('DemoDataAlert')) : {}
      let data = JSON.parse(evt.data).data.k

      setPercentages(prevState => {
        const newState = prevState.map(obj => {

          // if the symbol exist in the table
          if ((obj.symbol+suffix1 === data.s) || (obj.symbol+suffix2 === data.s)) {
            let percent = ((data.c-data.o)/data.c)
            if(percent !== 0){
              // ALERT 
              checkForAlert('c1m', obj.symbol, percent, '1 minute', Alert)

              return {...obj, usd1min: percent};
            }
          }

          // otherwise return object as is
          return obj;
        });

        return newState;
      });
    }

    connection1minute.onerror = evt => {
        console.error(evt);
    }

    return () => {connection1minute.close();}

  }

  const get3Minute = (url, suffix1, suffix2) => {

    let connection = new WebSocket(url);
    connection.onmessage = evt => { 
      let Alert = localStorage.getItem('DemoDataAlert') ? JSON.parse(localStorage.getItem('DemoDataAlert')) : {}
      let data = JSON.parse(evt.data).data.k
      setPercentages(prevState => {
        const newState = prevState.map(obj => {

          // if the symbol exist in the table
          if ((obj.symbol+suffix1 === data.s) || (obj.symbol+suffix2 === data.s)) {
            let percent = ((data.c-data.o)/data.c)
            if(percent !== 0){
              // ALERT
              checkForAlert('c3m', obj.symbol, percent, '3 minutes', Alert)
              
              return {...obj, usd3min: percent};
            }
          }

          // otherwise return object as is
          return obj;
        });

        return newState;
      });
    }

    connection.onerror = evt => {
        console.error(evt);
    }

    return () => {connection.close();}

  }


  const getSecondPrices_USDT = () => {
    let connection = new WebSocket(`wss://fstream.binance.com/ws/!markPrice@arr@1s`);
    connection.onmessage = evt => { 

      countLast10s++ 
      if(countLast10s === 10 ){
        countLast10s = 0
      }

      // Start Calculating the Percentages after 10s
      if(Last10s.length === 10){
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            let data10s = Last10s[countLast10s].findIndex(data => data.s === obj.symbol + 'USDT');

            // if the symbol exist in the table
            if(data10s !== -1){
              let newPrice = JSON.parse(evt.data)[data10s].p

              // RETURN 
              return {...obj, price: newPrice };
            }

            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      } // Update the price
      else{
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            if(Last10s[0]){
              let data10s = Last10s[0].findIndex(data => data.s === obj.symbol + 'USDT');

              // if the symbol exist in the table
              if(data10s !== -1){
                // RETURN 
                return {...obj, price: JSON.parse(evt.data)[data10s].p };
              }
            }
            
            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      }
      // Collect Last 10 seconds 
      Last10s[countLast10s] = JSON.parse(evt.data)
    }

    connection.onerror = evt => {
        console.error(evt);
    }

    return () => {connection.close();}

  }

  
  // Column:c5m, symbol:pbj.Symbol = BTC, newPercent:percent, lastX: 5 
  const checkForAlert = (column, symbol, newPercent, lastX, Alert) =>{
    if(Alert[column] && ((Alert[column].gt <= newPercent*100 ) || (Alert[column].lt >= newPercent*100))){
      let message = '(' + symbol + `) Last ${lastX} = ` + new BigNumber(newPercent*100).toFormat(2,1) + ' %'
      runAlert(message, symbol+column, Alert[column].sound, Alert[column].emailNotif)
    }

  }

  const runAlert = async (text, customId, sound, emailNotif) => {
    let timeSpace = (Date.now() - timeSendMail)/1000
    if(emailNotif && (timeSpace>60)){
      timeSendMail = Date.now()
      let {name, email} = JSON.parse(localStorage.getItem('userEmail'))
      let details = 'Alert Description...'
      const res = await axios.post('https://iq-screener-backend-a7au.vercel.app/api/crypto/sendAlert', { name, email, details })
    }

    setActiveAlert(true)

    toast.info(text, { containerId:'CoinsAlert', toastId: customId, theme: "colored" })
    switch(sound){
      case "sound_1":
        audioAlert1.play()
        break;
      case "sound_2":
        audioAlert2.play()
        break;
      case "sound_3":
        audioAlert3.play()
        break;
      case "sound_4":
        audioAlert4.play()
        break;
      case "sound_5":
        audioAlert5.play()
        break;
      case "sound_6":
        audioAlert6.play()
        break;
      default:
        audioAlert1.play()
        break;
    }

  }

  const handleDeleteAlert = () => {
    toast.dismiss();
    setActiveAlert(false)
  }

  const handleStopAlert = () => {
    localStorage.setItem('DemoDataAlert', JSON.stringify({}));

    setAlert({ c10s:false, c20s:false, c30s:false, c1m:false, c3m:false, c5m:false, 
      c1h:false, c2h:false, c3h:false, c4h:false, c1d:false, c7d:false, c30d:false, c1y:false})
  }

  const handleSearch = (e) => {
    setSearchText(e.target.value)
  }


  return (
    loading ? <Loader/>:    
    <div className="container-fluid">
      <div className='top-table mb-3 '>
        <Form.Select className="mr-3" id="dataType">
          <option value="USDT" selected >Futures USDT (Binance)</option>
          <option value="SPOT" disabled >SPOT</option>
        </Form.Select>

        <Form.Group className="d-flex justify-content-center" controlId="formBasicPassword">
          <input type="text" placeholder="Search ..." id="search" name="search" 
          onChange={handleSearch} className="searchInput label-input form-control"/>   
        </Form.Group>
      </div>

      <div className="row">
          <div className="col-12">
            <DemoDataTable percentages={percentages} alert={alert} setAlert={setAlert} searchText={searchText}/>
          </div>
      </div> 
      <div className='Alert-Modal'>
        <Alert show={activeAlert} variant="dark">
          <div className="alert-settings d-flex justify-content-between align-items-center">
            <Button onClick={() => handleStopAlert()} size="sm" variant="outline-danger">
              Disable All
            </Button>
            <Button onClick={() => handleDeleteAlert()} size="sm" variant="outline-secondary">
              Hide All
            </Button>
          </div>
        </Alert>
      </div>
    </div> 
  )
}

export default DemoTable